





























































































import Vue from "vue";
import { mapGetters } from "vuex";

// Components
import BagsCashFlowTimeline from "@/views/App/CashFlow/BagsCashReport/BagsCashFlowTimeline.vue";

// Model
import moment from "moment";
import { formatCurrency } from "@/utility/Formatter.js";
import { transactionTypeEnumLabel } from "@/model/data/enums/TransactionTypeEnum";
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";
import { BagsCashReportEntry } from "@/model/data/bagsCashReport/BagsCashReportEntry";
import { GetBagsCashReportReqData } from "@/model/communication/bagsCashReport/GetBagsCashReportReqData";
import { cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";

export default Vue.extend({
    components: {
        BagsCashFlowTimeline,
    },
    data() {
        return {
            cashTypeEnumLabel,
            moment,
            TransactionFlowEnum,
            headers: [
                { text: this.$t("common.bagId"), value: "bagId", sortable: true },
                // { text: this.$t("common.bagPosition"), value: "bagPosition", sortable: false },
                // { text: this.$t("common.transactionId"), value: "transactionId", sortable: false },
                { text: this.$t("common.timestamp"), value: "transactionTimestamp", sortable: true },
                { text: this.$t("bagsCashReport.transactionType"), value: "transactionType", sortable: false },
                // { text: this.$t("common.installationName"), value: "installationName", sortable: false },
                // { text: this.$t("common.machineId"), value: "machineId", sortable: false },
                // { text: this.$t("common.cashType"), value: "cashType", sortable: false },
                // { text: this.$t("common.flow"), value: "flow", sortable: false },
                { text: this.$t("bagsCashReport.amount"), value: "cashValue", sortable: false, align: "end" },
            ],
        };
    },
    props: {
        showDetailsDialogEntry: { type: Object as () => BagsCashReportEntry },
        filters: { type: Object as () => GetBagsCashReportReqData },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),

        subtitle() {
            var res = "";
            res += this.$t("common.installation") + ": " + (this.showDetailsDialogEntry as BagsCashReportEntry).installationName;
            res += "\n" + this.$t("common.machine") + ": " + (this.showDetailsDialogEntry as BagsCashReportEntry).machineSerialNumber;
            return res;
        },
    },
    methods: {
        formatCurrency,
        transactionTypeEnumLabel,
        longDateFormatMethod(withTime: boolean, fourD: boolean, fourM: boolean, withoutDay: boolean, withoutSeconds: boolean) {
            return this.longDateFormat(withTime, fourD, fourM, withoutDay, withoutSeconds);
        },
    },
});
